import PropTypes from 'prop-types';
import React from 'react';
import { formatPrice } from './utils/ProductUtils';
import { UX2 } from '@wsb/guac-widget-core';

const FormattedNumber = props => {
  const { Text } = UX2.Element;
  const styles = {
    display: 'inline-block',
    ...props.style
  };

  return <Text children={ formatPrice(props) } { ...props } style={ styles } />;
};

FormattedNumber.propTypes = {
  number: PropTypes.number,
  currency: PropTypes.bool,
  percentage: PropTypes.bool,
  precision: PropTypes.any,
  style: PropTypes.object
};

export default FormattedNumber;
